import { WithChildren } from '../../../core/types/with-children.js';
import { convertDateCompatibleToTimestamp } from '../../core/utils/convert-dates.js';
import { isDateCompatibleToTimestamp } from '../../core/utils/is-date.js';
import { TimeseriesMinMaxXAxisContext } from '../context/TimeseriesMinMaxXAxis.context.js';
import { useTimeseriesData } from '../hooks/useTimeseriesData.js';
import { useXAxisConfig } from '../hooks/useXAxisConfig.js';
import { getXAxisRange } from '../utils/x-axis.js';

export const TimeseriesMinMaxXAxisProvider = ({ children }: WithChildren) => {
  const { dataPerVariant: data } = useTimeseriesData();
  const { min: minFromData, max: maxFromData } = getXAxisRange(data);
  const { min: minFromConfig, max: maxFromConfig } = useXAxisConfig() ?? {};
  const min = isDateCompatibleToTimestamp(minFromConfig)
    ? minFromConfig
    : minFromData;
  const max = isDateCompatibleToTimestamp(maxFromConfig)
    ? maxFromConfig
    : maxFromData;

  const minConverted = convertDateCompatibleToTimestamp(min);
  const maxConverted = convertDateCompatibleToTimestamp(max);

  const minMaxValues = { min: minConverted, max: maxConverted };

  return (
    <TimeseriesMinMaxXAxisContext.Provider value={minMaxValues}>
      {children}
    </TimeseriesMinMaxXAxisContext.Provider>
  );
};

TimeseriesMinMaxXAxisProvider['displayName'] = 'TimeseriesMinMaxXAxisProvider';
